import { useTranslation } from 'react-i18next';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  SectionContainer,
} from './SegmentationTwo.style';

const segmentationTwo = () => {
  const { t } = useTranslation('segmentation');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('segmentationTwo.title')}</h1>
        <StyledHr />
      </SectionWrapper>
      <ContentWrapper>
        <div>
          <TextBox1>
            <p>
              <span>1.</span>
              {t('segmentationTwo.paragraphOne.title')}
            </p>
            <TextBox2>
              <p>{t('segmentationTwo.paragraphOne.paragraph')}</p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1>
            <p>
              <span>2.</span>
              {t('segmentationTwo.paragraphTwo.title')}
            </p>
            <TextBox2>
              <p>{t('segmentationTwo.paragraphTwo.paragraph')}</p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1 className="empty-content">
            <p></p>
            <TextBox2>
              <p></p>
            </TextBox2>
          </TextBox1>
        </div>

        <div>
          <TextBox1 className="empty-content">
            <p></p>
            <TextBox2>
              <p></p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1 className="content-left">
            <p>
              <span>3.</span>
              {t('segmentationTwo.paragraphThree.title')}
            </p>
            <TextBox2>
              <p>{t('segmentationTwo.paragraphThree.paragraph')}</p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1 className="content-left">
            <p>
              <span>4.</span>
              {t('segmentationTwo.paragraphFour.title')}
            </p>
            <TextBox2>
              <p>{t('segmentationTwo.paragraphFour.paragraph')}</p>
            </TextBox2>
          </TextBox1>
        </div>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default segmentationTwo;
